import React from 'react';
import { BarcodeLabelPath } from './MarketplaceLabels';

const D9 = (props) => (
  <svg width={80} height={80} viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
    <BarcodeLabelPath fill="#4B5564" />
  </svg>
);
export default D9;
